import { useUpdate } from '../../../api';

interface Props {
  id: string;
  msg?: string;
}

const useCancel = ({ id, msg }: Props) => {
  const {
    mutateAsync: cancel,
    isLoading: isRejecting,
    error,
  } = useUpdate({
    url: 'letter-generation/employees/letter-requests/cancel',
    id,
    customInvalidateQueriesUrl: 'letter-generation/employees/letter-requests',
    msg,
  });

  return {
    isRejecting,
    error,
    cancel,
  };
};

export { useCancel };
